var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.52,7.29c0,1.66-1.35,3.01-3.01,3.01-1.66,0-3.01-1.35-3.01-3.01,0-1.66,1.35-3.01,3.01-3.01,1.66,0,3.01,1.35,3.01,3.01,0,0,0,0,0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.31,10.96h-3.58c-1.31,0-2.51.76-3.06,1.95,1.73.32,3.13,1.56,3.66,3.24h5.36c.56,0,1.02-.46,1.02-1.02v-.78c0-1.87-1.52-3.38-3.39-3.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.63,5.22c-2.03,0-3.68,1.64-3.68,3.67,0,2.03,1.64,3.68,3.67,3.68,2.03,0,3.68-1.64,3.68-3.67,0,0,0,0,0,0,0-2.03-1.64-3.67-3.67-3.68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.97,18.48v-.94c0-2.29-1.85-4.14-4.14-4.15,0,0,0,0,0,0h-4.37c-2.29,0-4.14,1.85-4.14,4.14v.95c0,.69.56,1.24,1.25,1.24h10.18c.69,0,1.24-.56,1.24-1.24h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/Customers.ea0f06e9898f3ed555cc4a6f158c2c9d.svg";
export { ForwardRef as ReactComponent };